module.exports = __webpack_public_path__ + "img/tree.ccd3b798.jpg";